import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CanActivateChild, CanLoad } from '@angular/router';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { Route } from '@angular/router';

@Injectable()
export class UserGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(
    private router: Router,
    private userService: UserService,
  ) {
  }

  canActivate( next: ActivatedRouteSnapshot, state: RouterStateSnapshot ):
  Observable<boolean> | Promise<boolean> {
    return this.userService.hasUserDetails().map(
      (data) => {
        return data;
      }
    );
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot)
   : boolean | Observable<boolean> | Promise<boolean> {
    return this.userService.hasUserDetails().map(
      (data) => {
        return data;
      }
    );
  }

  public canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> {
    const hasAccess =  this.userService.hasUserDetails();
    hasAccess.subscribe(
      (data) => {
        return data;
      }
    );
    if (!hasAccess) {
      this.router.navigate(['/restrict/nodetails']);
    }
    return hasAccess;
  }
}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/guard/user.guard.ts